import request from '@aned/request';

// 获取鹰眼字典数据
export const selectByTypeCodes = (params) => {
  return request(`/api/dictionary/selectByTypeCodes`, {
    method: 'POST',
    body: params,
    reqType: 'format',
    module: 'mdp-dictionary',
  });
}
